<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[
            { text: $t('containerGroups.containerGroups'), name: 'company_container_groups' },
            {
              text: containerGroup.name,
              name: 'company_container_group',
              params: { container_group_uuid: $route.params.container_group_uuid },
            },
            { text: $t('containers.emptyDate') },
          ]"
        />
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <EmptyingTemplateShowForm
          v-if="Object.keys(emptyTemplate).length > 0"
          :currentEmptyTemplate="emptyTemplate"
          :afterSubmit="onSubmit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumbs from '@/components/BreadCrumbs'
import EmptyingTemplateShowForm from '@/components/EmptyingTemplates/ShowForm.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav.vue'

import containerGroupsApi from '@/api/containerGroups'
import emptyTemplatesApi from '@/api/emptyTemplates'

export default {
  name: 'containerGroupEmptyTemplate',
  data: () => ({
    containerGroup: {},
    emptyTemplate: {},
  }),
  components: {
    BreadCrumbs,
    CompanyNav,
    EmptyingTemplateShowForm,
    SectionHeader,
  },
  methods: {
    async getData() {
      const result = await containerGroupsApi.get(this.$route.params.container_group_uuid)
      this.containerGroup = result.success ? result.containerGroup : null

      this.emptyTemplate = await emptyTemplatesApi.getFromGroup(
        this.$route.params.container_group_uuid,
        this.$route.params.template_uuid,
      )
    },
    async onSubmit(newTemplateData) {
      const result = await emptyTemplatesApi.updateToGroup(
        this.$route.params.container_group_uuid,
        this.$route.params.template_uuid,
        newTemplateData,
      )
      if (result.success) await this.getData()
    },
  },
  async mounted() {
    await this.getData()
  },
}
</script>
